import { Component, OnInit } from "@angular/core"
import { EduComponent } from "../../../utils/eduComponent"
import { ResourceService } from "../../../services/resource.service"
import { CHNode } from "../../../models/node.model"
import { Resource } from "../../../models/resource/resource"
import { UserService } from "../../../services/user.service"
import { StudentGateService } from "../../../services/student-gate.service"
import { Observable } from "rxjs"
import { PreviewService } from "../../../services/preview.service"

@Component({
    selector: "app-curriculum-tags",
    templateUrl: "./curriculum-tags.component.html",
    styleUrls: ["./curriculum-tags.component.scss"],
    standalone: false,
})
export class CurriculumTagsComponent extends EduComponent implements OnInit {
    curriculumTags: any[] = []
    isStudent: boolean = false
    selectedGrade: string | null
    isInPreviewMode$: Observable<boolean>

    constructor(
        private resourceService: ResourceService,
        public userService: UserService,
        private studentGateService: StudentGateService,
        private previewService: PreviewService
    ) {
        super()
    }

    ngOnInit() {
        this.isInPreviewMode$ = this.previewService.previewOnResource$
        this.isStudent = this.userService.hasStudentExperience()
        this.selectedGrade = this.isStudent ? this.studentGateService.selectedGradeValue : null
        this.addSub(
            this.resourceService.resourceResponse.subscribe((resource: Resource) =>
                this.setTags(resource.curriculumTags)
            )
        )
    }

    setTags(newTags) {
        this.curriculumTags = newTags.map((tag) => {
            return {
                ...tag,
                colorClass: this.convertDiscipleToClass((tag.branch || {}).name),
                browseLink: this.getBrowseURL(tag),
                levelClass: (() => {
                    let className
                    switch (tag.ancestor_ids.length) {
                        case 0:
                            className = "gtm-curriculum-first-level"
                            break
                        case 1:
                            className = "gtm-curriculum-second-level"
                            break
                        case 2:
                            className = "gtm-curriculum-third-level"
                            break
                        case 3:
                            className = "gtm-curriculum-fourth-level"
                            break
                        case 4:
                            className = "gtm-curriculum-fifth-level"
                            break
                        case 5:
                            className = "gtm-curriculum-sixth-level"
                            break
                        default:
                            className = "gtm-curriculum-tag"
                    }
                    return className
                })(),
            }
        })
    }

    getBrowseURL(tag) {
        return CHNode.getBrowseURLForSlug(tag.slug)
    }

    convertDiscipleToClass(discipline) {
        switch (discipline) {
            case "Science":
                return "science"
            case "Social Studies":
                return "social-studies"
            case "Mathematics":
                return "mathematics"
            case "English Language Arts & Literacy":
                return "ela"
            case "Engineering & Technology":
                return "engineering-technology"
            case "Health and Physical Education":
                return "health-physical-education"
            case "Preschool":
                return "preschool"
            case "Professional Development":
                return "professional-development"
            case "The Arts":
                return "the-arts"
            case "World Languages":
                return "world-languages"
            default:
                return "science"
        }
    }
}
